import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ModalStyled from '@components/modal/ModalStyled';
import { AnalyticsContextProvider, useAnalytics } from '@lusha-engage/analytics';
import { useAppDispatch, useAppSelector } from '@reducers/index';
import UserActivityDispatcher from '@reducers/userActivity/dispatcher';
import dayjs from 'dayjs';
import React, { useEffect, useMemo } from 'react';
import LeaveFeedbackView from './views/LeaveFeedbackView';
import RateTopView from './views/RateTopView';
import RateView from './views/RateView';
const RateExtensionModal = () => {
    const dispatch = useAppDispatch();
    const { isModalVisible, currentRate, currentTriggerAction, firstOpenedAt, totalContactRevealsCount } = useAppSelector(state => (Object.assign({}, state.userActivity)));
    const analytics = useAnalytics();
    const days_since_installation = useMemo(() => {
        if (!firstOpenedAt)
            return undefined;
        return dayjs().diff(dayjs(firstOpenedAt), 'days');
    }, [firstOpenedAt]);
    function handleClose() {
        dispatch(UserActivityDispatcher.handleModalClose());
    }
    function handleRateSubmit(selectedRate) {
        dispatch(UserActivityDispatcher.actions.setCurrentRate(selectedRate));
    }
    function handleStoreRedirect() {
        dispatch(UserActivityDispatcher.handleStoreRedirect());
    }
    function handleFeedbackSubmit(feedbackText) {
        return dispatch(UserActivityDispatcher.handleFeedbackSubmit(feedbackText));
    }
    function handleSkip() {
        dispatch(UserActivityDispatcher.handleSkip());
    }
    const viewElement = useMemo(() => {
        if (!currentRate)
            return _jsx(RateView, { onRateSubmit: handleRateSubmit });
        if (currentRate === 5)
            return _jsx(RateTopView, { onRateUsOnStore: handleStoreRedirect });
        return _jsx(LeaveFeedbackView, { onSubmit: handleFeedbackSubmit, onSkip: handleSkip });
    }, [currentRate]);
    useEffect(() => {
        if (isModalVisible) {
            analytics.track({
                eventType: 'feedback_rating_displayed',
                event_trigger_type: currentTriggerAction,
                event_additional_info: {
                    days_since_installation,
                    total_contact_reveals_lifetime: totalContactRevealsCount,
                },
            });
        }
    }, [isModalVisible]);
    return (_jsx(ModalStyled, { isVisible: isModalVisible, onClose: handleClose, children: _jsx(AnalyticsContextProvider, { event_value: currentRate, event_trigger_type: currentTriggerAction || undefined, event_additional_info: { days_since_installation, total_contact_reveals_lifetime: totalContactRevealsCount }, children: viewElement }) }));
};
export default RateExtensionModal;
